import api from './api';

export interface SerialNumber {
  id: number;
  activityId: number;
  serialNumber: string;
  createdUserId: number;
  updatedUserId?: number;
  createdDate: string;
  updatedDate?: string;
  deactivatedDate?: string;
}

export interface CreateSerialNumberRequest {
  activityId: number;
  serialNumber: string;
}

export const serialNumberService = {
  // Get all serial numbers for an activity
  getByActivityId: async (activityId: number): Promise<SerialNumber[]> => {
    const response = await api.get(`/product-serial-numbers/activity/${activityId}`);
    return response.data;
  },

  // Create a new serial number
  create: async (request: CreateSerialNumberRequest): Promise<SerialNumber> => {
    const response = await api.post('/product-serial-numbers', request);
    return response.data;
  },

  // Delete a serial number
  delete: async (id: number): Promise<void> => {
    await api.delete(`/product-serial-numbers/${id}`);
  },
};
